module.exports = __webpack_public_path__ + "static/img/revisit_contract_step_2.8682211.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/revisit_contract_step_2.png
// module id = TkF2
// module chunks = 1